/**
 * ゲストユーザー管理ユーティリティ
 */

const GUEST_USER_ID_KEY = 'guestUserId';

/**
 * ゲストユーザーIDを生成または取得
 * localStorageに既存のIDがあればそれを返し、なければ新しいUUIDを生成して保存
 */
export function getOrCreateGuestUserId(): string {
  // 既存のゲストユーザーIDを確認
  const existingId = localStorage.getItem(GUEST_USER_ID_KEY);
  
  if (existingId && existingId.trim() !== '') {
    return existingId;
  }
  
  // 新しいUUIDを生成
  const newId = generateUUID();
  localStorage.setItem(GUEST_USER_ID_KEY, newId);
  
  return newId;
}

/**
 * 現在のゲストユーザーIDを取得（存在しない場合はnull）
 */
export function getCurrentGuestUserId(): string | null {
  return localStorage.getItem(GUEST_USER_ID_KEY);
}

/**
 * ゲストユーザーIDをクリア
 */
export function clearGuestUserId(): void {
  localStorage.removeItem(GUEST_USER_ID_KEY);
}

/**
 * UUID v4を生成
 */
function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
}